import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";

//redux
import {
  getEstados,
  editestado,
  deleteEstado,
  saveEstados,
} from "../../../redux/seleccionContratacion/estados/actions";
import { HexColorPicker } from "react-colorful";

const schema = Yup.object().shape({
  nombre_estado: Yup.string().ensure().required("**Campo requerido"),
  color_mostrar: Yup.string().required("**Campo requerido"),
});

const Estados = (props) => {
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre del estado",
  });

  const dispatch = useDispatch();
  const estadosStore = useSelector((store) => store.estados);
  const {
    estados,
    loaderEstados,
    estadosFalla,
    estadosFormError,
    saveLoaderEstados,
  } = estadosStore;

  //Datos para el custom table

  useEffect(() => {
    _getEstados();
  }, []);
  const pages = Math.ceil((estados ? estados.count : 0) / limit);
  const columns = [
    {
      Header: "Nombre del estado",
      accessor: "nombre_estado",
    },
    {
      id: "color",
      Header: "Color asignado",
      Filter: "",
      Cell: (value) => (
        <div
          style={{
            backgroundColor: value.row.original.color_mostrar,
            padding: "1rem",
            width: "100px",
            height: "20px",
            borderRadius: "1.5rem",
          }}
        ></div>
      ),
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          {parseInt(value.row.original.tipo_estado) === 2 && (
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const filters = [
    { id: "nombre_estado", desc: "Nombre del estado" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const _getEstados = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getEstados({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
        // filter:
        //   tipoBusqueda.id === "fecha_creacion"
        //     ? moment(filt).format("YYYY-MM-DD")
        //     : filt,
      })
    );

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(saveEstados(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editestado(req, index, setShowFormModal));
    }
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEstados(oOffset, limit, e.target.filter.value);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEstados(oOffset, limit, oSearch);
  };
  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEstado(id, data));
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">ESTADOS</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                {/* <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    {/* <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger> */}
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!estadosFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {estadosFalla}
            </Alert>
          )}
          {loaderEstados ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : estados != null && estados.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={estados.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={estados.count}
                pages={pages}
                pagFunc={_getEstados}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
      </div>
      {/*Modal editar*/}
      <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre_estado: edit ? editItem.nombre_estado : "",
            color_mostrar: edit ? editItem.color_mostrar : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            handleBlur,
            //isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  {edit ? "Editar estado" : "Crear estado"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {estadosFormError && typeof estadosFormError !== "object" ? (
                  <Alert variant="danger" className="my-2">
                    {estadosFormError}
                  </Alert>
                ) : null}
                {edit && parseInt(editItem.tipo_estado) === 1 ? (
                  <Alert variant="danger" className="my-2">
                    No se puede editar este estado porque es un valor reservado.
                  </Alert>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Nombre
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      name="nombre_estado"
                      className="rounded-pill"
                      required
                      type="text"
                      disabled={edit && parseInt(editItem.tipo_estado) === 1}
                      value={values.nombre_estado}
                      placeholder="Nombre"
                      onBlur={handleBlur("nombre_estado")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.nombre_estado && !!errors.nombre_estado
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_estado}
                    </Form.Control.Feedback>
                    {estadosFormError &&
                    typeof estadosFormError === "object" &&
                    estadosFormError.nombre_estado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {estadosFormError.nombre_estado.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Color de estado
                  </Form.Label>
                  <Col sm={9}>
                    <HexColorPicker
                      id="color_mostrar"
                      name="color_mostrar"
                      onBlur={handleBlur("color_mostrar")}
                      disabled={edit && parseInt(editItem.tipo_estado) === 1}
                      onInvalid={touched.color && !!errors.color}
                      color={values.color_mostrar}
                      onChange={(color) =>
                        setFieldValue("color_mostrar", color)
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_estado}
                    </Form.Control.Feedback>
                    {errors.color && (
                      <div>
                        <small className="text-danger">
                          {errors.id_encargado}
                        </small>
                      </div>
                    )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowFormModal(false)}
                >
                  Cerrar
                </Button>
                {edit && parseInt(editItem.tipo_estado) === 2 && (
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderEstados}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderEstados && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                )}
                {!edit && (
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderEstados}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderEstados && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/*Modal*/}
    </>
  );
};

export default Estados;
